module.exports = __webpack_public_path__ + "static/heritage_350-a000e072b24505b5aad1d1f2cae5be26.jpg";